import React from "react";
import { toAbsoluteUrl } from "../../../_helpers";

export function FooterCompact({
  today,
  footerClasses,
  footerContainerClasses,
}) {
  return (
    <>
      {/* begin::Footer */}
      <div
        className={`footer footer-color py-4 d-flex flex-lg-column  ${footerClasses}`}
        id="kt_footer"
      >
        {/* begin::Container */}
        <div className="footer-container">
          {/* begin::Nav */}
          <div className="nav nav-dark order-1 order-md-2 nav-container">
            <div className="kontakt-container">
              <img
                src={`${toAbsoluteUrl(
                  "/media/logos/MPKN-Vertical Logo-RGB-White_Medium-500.png"
                )}`}
                alt={"Logo 1"}
                className={"contact-logo"}
              />
              <div>
                <div className={"contact-text"}>Контакт</div>
                <div
                  style={{
                    lineHeight: 1.8,
                    fontSize: 18,
                    fontFamily: "AnonymousPro-Regular",
                  }}
                >
                  Национален комитет ИКОМОС Македонија <br />
                  Поштенски фах 816 <br />
                  Покриена чаршија 37 б, локал 13 <br />
                  1000 Скопје, С. Македонија <br />
                  (02) 3215 435 <br />
                  macedonia@icomos.org <br />
                  www.icomos.org.mk <br />
                </div>
              </div>
            </div>
            <div className="sponsorstva-container">
              <div className={"sponzorstvo-container-usa"}>
                <img
                  src={`${toAbsoluteUrl(
                    "/media/logos/US-EMB-Skopje-Seal.png"
                  )}`}
                  alt={"Logo USA"}
                  className={"sponsor-logo-1"}
                />
                <div className="beleska-tekst-usa">
                  Проектот во целост е поддржан од
                  <br /> Центарот за културно наследство на <br />
                  Стејт Департментот на САД
                </div>
              </div>
              <div className={"sponzorstvo-container-mpc"}>
                <div style={{ width: 93, height: 48 }}>
                  <img
                    src={`${toAbsoluteUrl("/media/logos/Logo-MPC-01.png")}`}
                    alt={"Logo MPC"}
                    className={"sponsor-logo-2"}
                  />
                </div>
                <div className="beleska-tekst-mpc">
                  Проектот се реализира во партнерство со <br /> Македонската
                  Православна Црква – <br /> Охридска Архиепископија
                </div>
              </div>
            </div>
          </div>
          {/* begin::Copyright */}
          <div className="order-2 order-md-1 copyright">
            <img
              src={`${toAbsoluteUrl("/media/logos/ICOMOS_Logo.png")}`}
              alt={"Logo 1"}
              className={"sponsor-logo-3"}
            />

            <div className="">
              <span className="font-weight-bold mr-2">{today} &copy;</span>
              ИКОМОС Македонија. Сите права се задржани.
            </div>
          </div>
          {/* end::Copyright */}
          {/* end::Nav */}
        </div>
        {/* end::Container */}
      </div>
      {/* end::Footer */}
    </>
  );
}
